module.exports = __webpack_public_path__ + "static/steve-574ae1b3147db02016d32c88a8da133e.jpg";